import RevolverModel from 'slotworks/integration/revolver/model/revolver-model';
import { ResultsAndDetail } from 'slotworks/integration/revolver/schema/spin-record-schema';
import Result from 'slotworks/model/gameplay/records/results/result';
import ScatterResult from 'slotworks/model/gameplay/records/results/scatter-result';
import SpinRecord from 'slotworks/model/gameplay/records/spin-record';
import { ResultBuilder } from 'slotworks/server/builders/result-builder';
import SymbolModel from 'slotworks/server/symbols/symbol-model';
import BuyoutResult from './buyout-result';
import { BuyoutTypes } from 'components/bonus-buy/bonus-buy-prompt';

class DOScatterResultBuilder implements ResultBuilder {
    public filter(data: any): boolean {
        const resultsAndDetail = data as ResultsAndDetail;

        if (!resultsAndDetail) {
            return false;
        }

        const detail = resultsAndDetail.detail;

        return detail && detail.type && detail.type === '$SCATTER';
    }

    public build(record: SpinRecord, data: any): Result[] {
        const resultsAndDetail = data as ResultsAndDetail;
        const detail = resultsAndDetail.detail;

        const result = new ScatterResult();
        result.creditsWon = detail.cash;
        result.matches = detail.positions.length;
        result.symbolType = SymbolModel.convertSymbolToSlotworks(detail.symbol);

        if (RevolverModel.isFreespin(detail.feature)) {
            result.freespinsWon = resultsAndDetail.results.eval.freeSpinsCount;
        }

        result.positions = RevolverModel.convertPositionsToGridPositions(detail.positions);

        const results: Result[] = [result];

        if (resultsAndDetail.results.state.game == 'BUYOUT_SPINS') {
            const buyoutResult = new BuyoutResult();
            buyoutResult.freespinsWon = resultsAndDetail.results.next_game_state?.total || 0;
            buyoutResult.type = BuyoutTypes.BUYOUT_SPINS;
            buyoutResult.totalBetCash = resultsAndDetail.results.total_bet_cash;
            results.push(buyoutResult);
        } else if (resultsAndDetail.results.state.game == 'BUYOUT_BONUS') {
            const buyoutResult = new BuyoutResult();
            buyoutResult.type = BuyoutTypes.BUYOUT_BONUS;
            buyoutResult.totalBetCash = resultsAndDetail.results.total_bet_cash;
            results.push(buyoutResult);
        }

        return results;
    }
}

export default new DOScatterResultBuilder();



// WEBPACK FOOTER //
// ./src/integration/scatter-result-builder.ts